import React from 'react'

import { OrderBillItem, useOrderBill } from 'compositions/orderItems'


type CartBillProps = {
  className?: string
  cart: CartModule.Cart
}

const CartBill: React.FunctionComponent<CartBillProps> = (props) => {
  const { className, cart } = props

  const { discounts, shipping, credits, subTotal, total } = cart || {}
  const bill = useOrderBill({ discounts, shipping, credits, subTotal, total })

  return (
    <div className={className}>
      {
        bill.map(({ label, note, value, isSubTotal, isTotal, dataTestId }, index) => (
          <OrderBillItem
            key={index}
            className={index ? 'mt-16' : null}
            label={label}
            note={note}
            value={value}
            isLarge={isSubTotal || isTotal}
            data-testid={dataTestId}
          />
        ))
      }
    </div>
  )
}


export default CartBill
